import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

/**
 * Abstract Consult-Request Home service
 */
@Injectable({
	providedIn: 'root'
})
export abstract class AbstractService {
	/**
	 * Gets the name
	 */
	abstract getName(): Observable<string>;
}
